import { ITimelineDot } from "src/modules/pe-landing-module/data/interfaces"

/* Protopia Ecosystem component */
export interface IVerticalTimelineTitleProps {
   card: ITimelineDot
}
const VerticalTimelineTitle = (props: IVerticalTimelineTitleProps): JSX.Element => {
    if(!props.card.title && !props.card.defaultTitle) {
        return <></>
    }
    return <div className='landing-vertical-timeline-title-container'>
       { props.card.title || props.card.defaultTitle }
    </div>
}
export default VerticalTimelineTitle